module.exports = __webpack_public_path__ + "static/media/add hw.28795904.svg";